

























































































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions, mapGetters } from 'vuex';
import { CatalogItem } from '@/requests/mainApi';
import { BASE_PATH } from '@/requests/requestMachine';
import { getAccessToken } from '@/utils/plugins/jwt';

interface Data {
  isInstructionShowed: boolean;
  isSuccessShowed: boolean;
}

interface Methods {
  showInstruction: () => void;
  showSuccess: () => void;
  sendAgreementEmail: () => void;
}

interface Computed {
  apartmentAcceptanceFlatModel: null | CatalogItem;
}

interface Props {
  close: () => void | null;
}

export default Vue.extend({
  name: 'ApartmentAcceptanceModal',
  props: {
    close: null,
  },
  data() {
    return {
      isInstructionShowed: false,
      isSuccessShowed: false
    }
  },
  methods: {
    outsideClick(e: MouseEvent) {
      if (!this.$refs.modal || (this.$refs.modal as HTMLElement).contains(e.target as HTMLElement)) {
        return;
      }
      this.close();
    },
    showInstruction() {
      this.isInstructionShowed = true;
      this.isSuccessShowed = false;
    },
    showSuccess() {
      this.isSuccessShowed = true;
      this.isInstructionShowed = false;
    },
    sendAgreementEmail() {
      const token = getAccessToken();
      fetch(`${BASE_PATH}/catalog/v1/item/online-approve`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          object_id: this.apartmentAcceptanceFlatModel.id
        }),
      });
      this.showSuccess();
    },
    ...mapActions(['getBasisWidgetToken']),
  },
  computed: {
    ...mapGetters(['apartmentAcceptanceFlatModel']),
  },
  mounted() {

  },
  beforeDestroy() {

  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
